import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatDate } from '@/lib/utils';
import type { PsmfLogEntry } from './types';

interface Props {
  entries: PsmfLogEntry[];
  limit?: number;
}

export function LogbookWidget({ entries, limit = 15 }: Props) {
  const recent = [...entries].sort((a, b) => b.timestamp.localeCompare(a.timestamp)).slice(0, limit);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Change logbook</CardTitle>
        <p className="text-xs text-muted-foreground">
          GVP Module II Section C. Auto-captured on each field edit. Shows the {limit} most recent entries.
        </p>
      </CardHeader>
      <CardContent className="p-0">
        {recent.length === 0 ? (
          <div className="px-6 pb-6 text-sm text-muted-foreground">No changes recorded yet.</div>
        ) : (
          <div className="divide-y">
            {recent.map((e) => (
              <div key={e.id} className="px-6 py-2.5 text-xs">
                <div className="flex items-center justify-between">
                  <span className="font-mono text-muted-foreground">{formatDate(e.timestamp)}</span>
                  <span className="text-muted-foreground">{e.user}</span>
                </div>
                <div className="mt-0.5">
                  <span className="font-medium">{e.field}</span> — {e.summary}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
